export const widthPayments = [130, 130, 100, 250, 100, 125, 125, 125, 125, 125, 110]
// TOTAL 100
// export const widthGroupSchedule = [4,10,25,15,13,25,8];
// looks like bad, but i will modify it in the future
// when File name is string
// export const widthExpandedRowString = [widthPayments[0]+widthPayments[1],widthPayments[2]+widthPayments[3],widthPayments[4]]
// when File name is array
export const widthExpandedRowString = [130, 230, 200, 130]
// export const widthExpandedRowArray = [widthPayments[0],widthPayments[1]+widthPayments[2],widthPayments[3],widthPayments[4]]
export const widthExpandedRowArray = [120, 140, 200, 160]
/// /
// keys for status on payments table

// error message
// Dashboard
export const messageErrorDashboardData = 'Something went wrong when getting a Dashboard data'
export const messageErrorDashboardFilterType = 'Something went wrong when getting a file types'
export const messageErrorDashboardEventType = 'Something went wrong when getting a event types'

// Payment
export const messageErrorFilterStatuses = 'Something went wrong when getting statuses'
